import { extendObservable, runInAction } from 'mobx';

import { ERROR_CODES } from '../models/ApiError';
import { InstallationOptionsController } from '../networking/controllers/InstallationOptionsController';
import { Logger } from '../helpers/Logger';

class InstallationStoreClass {
  constructor() {
    extendObservable(this, {
      loading: false,
      installationOptions: null,
      invalidAddressError: null,
      noInstallationsError: null,
      error: null,

      coordinationError: false,
      loadingCoordination: false,
      coordinationSuccess: false,
    });
  }

  async fetchAllInstallationOptions(products, addressId, date) {
    runInAction(() => {
      this.loading = true;
      this.installationOptions = null;
      this.invalidAddressError = null;
      this.noInstallationsError = null;
      this.error = null;
    });
    try {
      const promises = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const index in products) {
        if (products[index]) {
          const p = InstallationOptionsController.allByArticle(
            addressId,
            products[index],
            date,
            index,
          );
          promises.push(p);
        }
      }
      const installationOptions = await Promise.all(promises);
      const result = {};
      let count = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const index in products) {
        if (products[index]) {
          result[index] = installationOptions[count];
          count += 1;
        }
      }
      runInAction(() => {
        this.installationOptions = result;
      });
    } catch (error) {
      if (error.code === ERROR_CODES.INVALID_INSTALLATION_ADDRESS) {
        runInAction(() => {
          this.invalidAddressError = error;
        });
      } else if (error.code === ERROR_CODES.NO_INSTALLATIONS_FOR_DATE) {
        runInAction(() => {
          this.noInstallationsError = error;
        });
      } else {
        Logger.warn(error);
        runInAction(() => {
          this.error = error;
        });
      }
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async fetchInstallationOptions(installationAmount, addressId, date) {
    runInAction(() => {
      this.loading = true;
      this.installationOptions = null;
      this.invalidAddressError = null;
      this.noInstallationsError = null;
      this.error = null;
    });
    try {
      const installationOptions = await InstallationOptionsController.all(
        addressId,
        installationAmount,
        date,
      );
      runInAction(() => {
        this.installationOptions = installationOptions;
      });
    } catch (error) {
      if (error.code === ERROR_CODES.INVALID_INSTALLATION_ADDRESS) {
        runInAction(() => {
          this.invalidAddressError = error;
        });
      } else if (error.code === ERROR_CODES.NO_INSTALLATIONS_FOR_DATE) {
        runInAction(() => {
          this.noInstallationsError = error;
        });
      } else {
        Logger.warn(error);
        runInAction(() => {
          this.error = error;
        });
      }
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async coordinateInstallation(checkoutId, installations) {
    runInAction(() => {
      this.coordinationError = false;
      this.loadingCoordination = true;
      this.coordinationSuccess = false;
    });
    try {
      await InstallationOptionsController.coordinate(checkoutId, installations);
      runInAction(() => {
        this.coordinationSuccess = true;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.coordinationError = true;
      });
    } finally {
      runInAction(() => {
        this.loadingCoordination = false;
      });
    }
  }

  clearCoordinationData() {
    runInAction(() => {
      this.coordinationError = false;
      this.coordinationSuccess = false;
      this.loadingCoordination = false;
    });
  }

  clearInstallations() {
    runInAction(() => {
      this.installationOptions = null;
      this.error = null;
    });
  }
}

const InstallationStore = new InstallationStoreClass();

export { InstallationStore };



// WEBPACK FOOTER //
// ./src/stores/InstallationStore.js